var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMadeWithLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "193px",
    height: "15px",
    viewBox: "0 0 193 15",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Winds-Webapp",
    transform: "translate(-863.000000, -8746.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-27",
    transform: "translate(-1.000000, 8145.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(864.000000, 601.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Made-with-in-India",
    fill: "#8B8B8B"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "11.6081698 11.1726541 11.6081698 0 8.84431986 0 5.81246021 7.67177745 2.76384996 0 0 0 0 11.1726541 1.95982088 11.1726541 1.95982088 2.54609208 5.39369507 11.1726541 6.23122536 11.1726541 9.64834894 2.54609208 9.64834894 11.1726541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7518118,11.1726541 L20.3631531,0 L17.9175647,0 L13.5289059,11.1726541 L15.7567365,11.1726541 L16.5775162,9.01182592 L21.7032016,9.01182592 L22.5239813,11.1726541 L24.7518118,11.1726541 Z M21.1504316,7.28651352 L17.1302862,7.28651352 L19.1403589,1.95982088 L21.1504316,7.28651352 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8266982,11.1726541 C34.3108242,11.1726541 36.655909,8.87782107 36.655909,5.57795173 C36.655909,2.3115836 34.3108242,0 30.8099476,0 L26.6557974,0 L26.6557974,11.1726541 L30.8266982,11.1726541 Z M30.8099476,9.44734167 L28.6156182,9.44734167 L28.6156182,1.7253124 L30.8266982,1.7253124 C33.3057879,1.7253124 34.6458363,3.43387419 34.6458363,5.57795173 C34.6458363,7.70527867 33.2387854,9.44734167 30.8099476,9.44734167 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "46.9016962 11.1726541 46.9016962 9.44734167 41.2064903 9.44734167 41.2064903 6.33172899 46.784442 6.33172899 46.784442 4.60641659 41.2064903 4.60641659 41.2064903 1.7253124 46.9016962 1.7253124 46.9016962 0 39.2466694 0 39.2466694 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "65.2659437 11.1726541 68.4653094 0 66.2709801 0 64.0934013 8.59306077 61.7818177 0 60.2240114 0 57.9124278 8.59306077 55.734849 0 53.5572703 0 56.7398854 11.1726541 58.8337111 11.1726541 61.0112898 2.91460541 63.172118 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "72.4128689 11.1726541 72.4128689 0 70.453048 0 70.453048 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "80.112564 11.1726541 80.112564 1.7253124 83.4961864 1.7253124 83.4961864 0 74.7691207 0 74.7691207 1.7253124 78.1527431 1.7253124 78.1527431 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "95.5845402 11.1726541 95.5845402 0 93.6247193 0 93.6247193 4.55616478 87.8122591 4.55616478 87.8122591 0 85.8524382 0 85.8524382 11.1726541 87.8122591 11.1726541 87.8122591 6.28147717 93.6247193 6.28147717 93.6247193 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "125.71888 11.1726541 125.71888 0 123.759059 0 123.759059 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "138.477258 11.1726541 138.477258 0 136.517437 0 136.517437 7.73877988 130.805481 0 128.795408 0 128.795408 11.1726541 130.755229 11.1726541 130.755229 3.1826151 136.58444 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "148.533205 11.1726541 148.533205 0 146.573384 0 146.573384 11.1726541"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "161.291583 11.1726541 161.291583 0 159.331762 0 159.331762 7.73877988 153.619806 0 151.609733 0 151.609733 11.1726541 153.569554 11.1726541 153.569554 3.1826151 159.398765 11.1726541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.539012,11.1726541 C172.023138,11.1726541 174.368223,8.87782107 174.368223,5.57795173 C174.368223,2.3115836 172.023138,0 168.522261,0 L164.368111,0 L164.368111,11.1726541 L168.539012,11.1726541 Z M168.522261,9.44734167 L166.327932,9.44734167 L166.327932,1.7253124 L168.539012,1.7253124 C171.018102,1.7253124 172.35815,3.43387419 172.35815,5.57795173 C172.35815,7.70527867 170.951099,9.44734167 168.522261,9.44734167 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "178.918804 11.1726541 178.918804 0 176.958983 0 176.958983 11.1726541"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.062446,11.1726541 L187.673787,0 L185.228199,0 L180.83954,11.1726541 L183.067371,11.1726541 L183.88815,9.01182592 L189.013836,9.01182592 L189.834615,11.1726541 L192.062446,11.1726541 Z M188.461066,7.28651352 L184.44092,7.28651352 L186.450993,1.95982088 L188.461066,7.28651352 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M109.461947,14.0333975 C107.187754,13.2570351 102.106109,10.0182713 102.106109,4.52884032 C102.106109,2.10564871 104.058778,0.145137838 106.466286,0.145137838 C107.893538,0.145137838 109.156107,0.835237915 109.948154,1.90175594 C110.7402,0.835237915 112.010612,0.145137838 113.430022,0.145137838 C115.837529,0.145137838 117.790198,2.10564871 117.790198,4.52884032 C117.790198,10.0182713 112.708553,13.2570351 110.43436,14.0333975 C110.167731,14.127502 109.728576,14.127502 109.461947,14.0333975 Z",
    id: "ic_heart",
    fill: "#F33434"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMadeWithLove);
export default __webpack_public_path__ + "static/media/ic_made_with_love.712f81fc1dbd71229574b35b5839be73.svg";
export { ForwardRef as ReactComponent };